// The UHF relies on jQuery, so we need to include it here - not just for the API call, but also for the UHF to work properly.
import $ from 'jquery';

let uhfLoadInProgress = false;
let uhfLoaded = false;

export interface UhfOptions {
    shellName?: string;
    headerId?: string;
    footerId?: string;
}

const defaultUhfOptions: UhfOptions = {
    shellName: 'OfficeProducts',
    headerId: 'DigitalSafetyHeader',
    footerId: 'DigitalSafetyFooter'
};

export function fetchHeaderFooter(locale: string, options: UhfOptions = defaultUhfOptions): void {
    const { shellName, headerId, footerId } = { ...defaultUhfOptions, ...options };

    if (uhfLoaded || uhfLoadInProgress) {
        return;
    }

    // If the red tiger UHF is present, do not run this code so as not to duplicate the UHF.
    // UHF 1.0 uses elements with IDs: headerArea and footerArea.
    // UHF 1.1 uses custom HTML elements : <uhf-header> and <uhf-footer>.
    // If any of these elements are present, we should not run this code - we don't want to add UHF if it's already there.
    if (document.getElementById("headerArea") ||
        document.getElementById("footerArea") ||
        document.querySelector("uhf-header") ||
        document.querySelector("uhf-footer")) {
        uhfLoaded = true;
        return;
    } // TODO: Once production no longer uses red tiger, remove this.

    uhfLoadInProgress = true;

    let url = `https://uhf.microsoft.com/${locale}/shell/xml/${shellName}?headerid=${headerId}&footerid=${footerId}`;

    const rootElement: HTMLElement|null = document.getElementById("root");

    $.ajax({
        method: "GET",
        url: url,
        dataType: "xml",
        timeout: 15000, // 15 second timeout
    }).done((msg: XMLDocument) => {
        try {
            var responsexml: XMLDocument = msg;
            let cssIncludesElement: HTMLElement = $(responsexml).find("cssIncludes")[0];
            if (cssIncludesElement && cssIncludesElement.childNodes[1]) {
                var cssIncludes: string = (cssIncludesElement.childNodes[1] as Text).data.trim();
                let styles: JQuery.Node[] = $.parseHTML(cssIncludes);
                $("head").append(styles);
            }

            let headerHtmlElement: HTMLElement = $(responsexml).find("headerHtml")[0];
            if (headerHtmlElement && headerHtmlElement.childNodes[1]) {
                var headerHtml: string = (headerHtmlElement.childNodes[1] as Text).data.trim();
                // Sometimes this call gets made multiple times before we are able to check if the header is already present.
                // If the header is already present, we don't want to add it again.
                if (rootElement && !document.getElementById("headerArea") && !document.querySelector("uhf-header")) {
                    let $header = $(headerHtml);
                    $('#root').before($header);
                }
            }

            let footerHtmlElement: HTMLElement = $(responsexml).find("footerHtml")[0];
            if (footerHtmlElement && footerHtmlElement.childNodes[1]) {
                var footerHtml: string = (footerHtmlElement.childNodes[1] as Text).data.trim();
                // Sometimes this call gets made multiple times before we are able to check if the footer is already present.
                // If the footer is already present, we don't want to add it again.
                if (rootElement && !document.getElementById("footerArea") && !document.querySelector("uhf-footer")) {
                    let $footer = $(footerHtml);
                    $('#root').after($footer);
                }
            }

            let javascriptIncludesElement: HTMLElement = $(responsexml).find("javascriptIncludes")[0];
            if (javascriptIncludesElement && javascriptIncludesElement.childNodes[1]) {
                var javascriptIncludes: string = (javascriptIncludesElement.childNodes[1] as Text).data.trim();
                let scripts: JQuery.Node[] = $.parseHTML(javascriptIncludes, true);
                $("head").append(scripts);
            }

            if (rootElement) {
                uhfLoaded = true;
            }
        } catch (error) {
        } finally {
            uhfLoadInProgress = false;
        }
    }).fail((error) => {
        uhfLoadInProgress = false;
    });
}
